import * as z from "zod";

export const LanguageEnumDto = {
    Spanish: "es",
    English: "en",
    French: "fr",
} as const;
export type LanguageEnumDto =
    (typeof LanguageEnumDto)[keyof typeof LanguageEnumDto];
export const LanguageEnumDtoSchema = z.enum(LanguageEnumDto);

export const LanguageDtoSchema = z
    .object({
        key: LanguageEnumDtoSchema.readonly(),
        value: z.string().trim(),
    })
    .readonly();

export type LanguageDto = z.output<typeof LanguageDtoSchema>;
